import { createAction, props } from '@ngrx/store';

import {
  ELink,
  ELinkDetail,
  ELinkManageOptions,
  ELinkSavePayload,
  ELinksListMeta,
  ELinksListParams,
} from '../models/e-link.model';

export const loadELinks = createAction(
  '[E-Links] Load E-Links',
  props<ELinksListParams>()
);

export const loadELinksSuccess = createAction(
  '[E-Links] Load E-Links Success',
  props<{ eLinks: ELink[]; meta: ELinksListMeta }>()
);

export const loadELinksFailure = createAction(
  '[E-Links] Load E-Links Failure',
  props<{ error: string }>()
);

export const deleteELink = createAction(
  '[E-Links] Delete E-Link',
  props<{ uuid: string }>()
);

export const deleteELinkSuccess = createAction('[E-Links] Delete E-Link Success');

export const mutationFailure = createAction(
  '[E-Links] Mutation Failure',
  props<{ error: string }>()
);

export const resetELinksState = createAction('[E-Links] Reset State');

/* -------------------------------------------------------------------------- */
/* Editor: options, single load, save                                          */
/* -------------------------------------------------------------------------- */

export const loadELinkOptions = createAction('[E-Links] Load Options');

export const loadELinkOptionsSuccess = createAction(
  '[E-Links] Load Options Success',
  props<{ options: ELinkManageOptions }>()
);

export const loadELinkOptionsFailure = createAction(
  '[E-Links] Load Options Failure',
  props<{ error: string }>()
);

export const loadELink = createAction('[E-Links] Load E-Link Detail', props<{ uuid: string }>());

export const loadELinkSuccess = createAction(
  '[E-Links] Load E-Link Detail Success',
  props<{ eLink: ELinkDetail }>()
);

export const loadELinkFailure = createAction(
  '[E-Links] Load E-Link Detail Failure',
  props<{ error: string }>()
);

export const saveELink = createAction(
  '[E-Links] Save E-Link',
  props<{ uuid?: string; payload: ELinkSavePayload }>()
);

export const saveELinkSuccess = createAction(
  '[E-Links] Save E-Link Success',
  props<{ eLink: ELinkDetail }>()
);

export const saveELinkFailure = createAction(
  '[E-Links] Save E-Link Failure',
  props<{ error: string; fieldErrors?: Record<string, string> }>()
);

export const resetELinkEditor = createAction('[E-Links] Reset Editor');
